const MuiCircularProgress = {
  styleOverrides: {
    root: {
      color: 'inherit',
    },
  },
}

export default MuiCircularProgress
